import { render } from "./FbFileUploadField.vue?vue&type=template&id=0ac3538c"
import script from "./FbFileUploadField.vue?vue&type=script&lang=js"
export * from "./FbFileUploadField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__